import { useAuthenticatedQuery } from 'flow/hooks/api/useAuthenticatedQuery';
import AiCoworkerResource from 'flow/api/aicoworker';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { calculateDateRange } from 'flow/utils/ai-coworker-date-utils';
import type { IntervalResolution } from 'flow/utils/ai-coworker-date-utils';

export interface AICoworkerStatsResponse {
    resolutionRate: number;
    satisfactionRate: number;
    coverageRate: number;
    numberOfCalls: number;
    resolved: number;
    failed: number;
    undetermined: number;
}

export const useAiCoworkerAggregatedEvals = (
    extensionKey: ExtensionKey,
    resolution: IntervalResolution = 'today',
) => {
    const fromDate = calculateDateRange(resolution);

    const { data, isLoading, error, refetch } =
        useAuthenticatedQuery<AICoworkerStatsResponse>({
            queryKey: ['aiCoworkerAggregatedEvals', extensionKey, resolution],
            queryFn: () =>
                new Promise<AICoworkerStatsResponse>((resolve, reject) => {
                    AiCoworkerResource.getAICoworkerEvalStats(
                        {
                            onResult: (json: AICoworkerStatsResponse) => {
                                resolve(json);
                            },
                            onError: reject,
                            onClientError: reject,
                        },
                        extensionKey,
                        fromDate,
                    );
                }),
            refetchInterval: 30000, // Refetch every 30 seconds
            staleTime: 30000, // Consider data stale after 30 seconds
        });

    return {
        data,
        isLoading,
        error,
        refetch,
    };
};
